import { render, staticRenderFns } from "./SafeProductionCommittee.vue?vue&type=template&id=44154952"
import script from "./SafeProductionCommittee.vue?vue&type=script&lang=js"
export * from "./SafeProductionCommittee.vue?vue&type=script&lang=js"
import style0 from "./SafeProductionCommittee.vue?vue&type=style&index=0&id=44154952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports